import React from 'react';
import { IconButton, useTheme } from '@mui/material';
import { DarkMode, LightMode } from '@mui/icons-material';
import { useThemeContext } from './ThemeContext';

const ThemeToggle = () => {
  const theme = useTheme();
  const { mode, toggleTheme } = useThemeContext();

  return (
    <IconButton
      onClick={toggleTheme}
      color="inherit"
      sx={{
        p: 1.2,
        borderRadius: '12px',
        bgcolor: mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
        '&:hover': {
          bgcolor: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
        },
        transition: 'all 0.3s ease',
      }}
    >
      {mode === 'dark' ? (
        <LightMode sx={{ color: '#ffb74d' }} />
      ) : (
        <DarkMode sx={{ color: '#1d64fa' }} />
      )}
    </IconButton>
  );
};

export default ThemeToggle;
